import moment from 'moment'

import allowances from 'modules/timeoff/store/collections/allowances'
import allowanceStats from 'modules/timeoff/store/collections/stats'
import policyTimelines from 'modules/timeoff/store/collections/timeoffPolicies/policyTimelines'
import type Allowance from 'modules/timeoff/store/models/Allowance'
import type Leave from 'modules/timeoff/store/models/Leave'
import { PolicyTimelineItem } from 'modules/timeoff/store/models/TimeoffPolicy/PolicyTimeline'

interface EffectiveAllowance {
  allowance: Allowance | undefined
  timelineItem: PolicyTimelineItem | undefined
}

const leaveEffectiveAllowance = (leave: Leave): EffectiveAllowance => {
  const timeline = policyTimelines.timeline
  const timelineItem = timeline?.items.find((item) =>
    moment(item.start_at).isSameOrBefore(leave.startOn)
  )

  const allowance = timelineItem
    ? allowances
        .filter((a) => a.attributes.timeoff_policy_id === timelineItem.timeoff_policy_id)
        .find((a) => a.attributes.leave_type_ids.includes(leave.attributes.leave_type_id))
    : undefined

  return { allowance, timelineItem }
}

const fetchStats = (leave: Leave, employeeId: string) => {
  if (!leave) return Promise.resolve()

  const { allowance, timelineItem } = leaveEffectiveAllowance(leave)
  if (!allowance) return Promise.resolve()

  const allowanceStat = timelineItem
    ? allowanceStats.findOrInitializeBy(employeeId, allowance, timelineItem.endAt)
    : null

  return allowanceStat ? allowanceStat.fetch() : Promise.resolve()
}

interface ReturnType {
  fetchStats: (leave: Leave, employeeId: string) => Promise<unknown>
}

const useFetchStats = (): ReturnType => {
  return {
    fetchStats,
  }
}

export default useFetchStats
